import(/* webpackMode: "eager" */ "/vercel/path0/thomas-gia/node_modules/next/dist/client/link.js")